import React, { useState, useEffect } from "react"
import BreathoText from "../components/BreathoText"

const backgroundImages = [
  "/images/bull.jpeg",
  "/images/escorrega.jpeg",
  "/images/lizzard.jpeg",
  "/images/people.jpeg",
]

export default function Home() {
  const [currentBackground, setCurrentBackground] = useState(0)

  useEffect(() => {
    const backgroundInterval = setInterval(() => {
      setCurrentBackground((prev) => (prev + 1) % backgroundImages.length)
    }, 4000)

    return () => {
      clearInterval(backgroundInterval)
    }
  }, [])

  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      {backgroundImages.map((src, index) => (
        <div
          key={src}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentBackground ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={src}
            alt={`Background ${index + 1}`}
            className="object-cover w-full h-full"
          />
        </div>
      ))}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <BreathoText />
      </div>
    </div>
  )
}
